import { useState, type FormEvent } from "react";
import { api } from "../api";

interface Props { onSuccess: () => void; }

export function LoginScreen({ onSuccess }: Props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.login(username.trim(), password);
      onSuccess();
    } catch (e: any) {
      setError(e.message || "Falha ao entrar");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form onSubmit={submit} style={{ maxWidth: 360, margin: "80px auto", padding: 32, background: "var(--sf)", border: ".5px solid var(--bd)", borderRadius: 14, fontFamily: "'DM Sans',sans-serif" }}>
      <h1 style={{ fontSize: 18, marginBottom: 6 }}>S&S Consultoria Securitária</h1>
      <p style={{ fontSize: 13, color: "var(--tx2)", marginBottom: 20 }}>Entrar no CRM</p>
      <div className="fr"><label htmlFor="lUser">Usuário</label><input id="lUser" type="text" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} /></div>
      <div className="fr"><label htmlFor="lPass">Senha</label><input id="lPass" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
      <div style={{ color: "#A32D2D", fontSize: 12, marginBottom: 8, minHeight: 16 }}>{error}</div>
      <button type="submit" className="btn-save" style={{ width: "100%" }} disabled={submitting}>Entrar</button>
    </form>
  );
}
